module.exports = __webpack_public_path__ + "img/bg.10cde3c7.jpg";